import { combineReducers } from 'redux';
import authenReducer from './authenReducer';

const rootReducer = combineReducers({
  authenRedux: authenReducer,
});

export default rootReducer;
